import styled from 'styled-components';
import { breakpoints } from 'styles';

export const Form = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;

  @media (max-width: ${breakpoints.l}px) {
    flex-direction: column;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
`;

export const CardHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CardHeaderTopColumn = styled.div`
  display: flex;
  align-items: center;

  h3 {
    margin-bottom: 0;
  }
`;

export const SelectListItem = styled.li`
  display: flex;
  margin: 16px 0;

  label {
    cursor: pointer;
    padding: 0 16px;
  }
`;

export const ButtonGrid = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: ${breakpoints.l}px) {
    width: 100%;
    justify-content: flex-end;
  }
  button {
    max-width: 200px;
    max-height: 60px;
  }
`;
